import { render } from "./Speaker.svg?vue&type=template&id=d314cbd4"
const script = {}
script.render = render

export default script